import firebase from 'firebase'
import Rebase from 're-base';

const config = {
    apiKey: "AIzaSyCQeYqiv9Ofc4P6NJHXL5uNzN3MGJs-iVo",
    authDomain: "solapo-9f572.firebaseapp.com",
    databaseURL: "https://solapo-9f572.firebaseio.com",
    projectId: "solapo-9f572",
    storageBucket: "solapo-9f572.appspot.com",
    messagingSenderId: "920216338972"
  };
  firebase.initializeApp(config);

export const ref = firebase.database().ref()
export const firebaseAuth = firebase.auth
export const base = Rebase.createClass(firebase.database());
export const storage = firebase.storage().ref()





// WEBPACK FOOTER //
// ./src/config/constants.js